import { useState, type FormEvent } from "react";
import { useAsyncAction } from "@/hooks/useAsyncAction";
import { api } from "@/lib/api";
import { validarPasswordNueva } from "@/lib/usuarios";

/** Lógica de la pantalla obligatoria del primer ingreso con contraseña temporal (sin JSX). */
export function usePrimerIngresoTab(onListo: () => Promise<void>) {
  const [password, setPassword] = useState("");
  const [repetida, setRepetida] = useState("");
  const [intentado, setIntentado] = useState(false);
  const accion = useAsyncAction((nueva: string) => api.post<void>("/api/perfil/password-inicial", { nueva }).then(() => true));
  const errorValidacion = validarPasswordNueva(password, repetida);

  const enviar = async (e: FormEvent) => {
    e.preventDefault();
    setIntentado(true);
    if (errorValidacion) return;
    // Con la propia elegida, /api/auth/yo ya no trae debe_cambiar_password y App muestra el resto.
    if (await accion.run(password)) await onListo();
  };

  return {
    password,
    setPassword,
    repetida,
    setRepetida,
    error: (intentado ? errorValidacion : null) ?? accion.error,
    enviar,
    guardando: accion.loading,
  };
}
